import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "sms-campaigns-period" };
const _hoisted_2 = { class: "sms-campaigns-period__title" };
const _hoisted_3 = { class: "sms-campaigns-period__container" };
const _hoisted_4 = { class: "sms-campaigns-period__time" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_8 = { class: "sms-campaigns-period__time" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1);
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
import { ref, shallowRef, h, watch, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsPeriod',
    setup(__props) {
        const store = useStore();
        const SEND_WINDOW = {
            START_HOUR: 8,
            END_HOUR: 22,
        };
        const date = computed({
            get: () => store.state.smsCampaigns.date,
            set: value => store.commit('smsCampaigns/SET_DATE', value),
        });
        const hour = computed({
            get: () => store.state.smsCampaigns.hour,
            set: value => store.commit('smsCampaigns/SET_HOUR', value),
        });
        const hasOutsideWindowError = ref(false);
        const hasMinimumAdvanceError = ref(false);
        const now = () => moment();
        const isToday = (date) => date.isSame(now(), 'day');
        const activeTooltipKey = computed(() => {
            if (hasOutsideWindowError.value)
                return 'sms-campaigns.period.tooltip-invalid-time-range-error';
            if (hasMinimumAdvanceError.value)
                return 'sms-campaigns.period.tooltip-minimum-advance-error';
            return null;
        });
        const shouldShowTooltip = computed(() => Boolean(activeTooltipKey.value));
        const validateSendWindow = () => {
            if (!hour.value) {
                hasOutsideWindowError.value = false;
                return;
            }
            const [selectedHour, selectedMinutes] = hour.value.split(':').map(Number);
            if (selectedHour < SEND_WINDOW.START_HOUR) {
                hasOutsideWindowError.value = true;
                return;
            }
            if (selectedHour > SEND_WINDOW.END_HOUR) {
                hasOutsideWindowError.value = true;
                return;
            }
            if (selectedHour === SEND_WINDOW.END_HOUR && selectedMinutes > 0) {
                hasOutsideWindowError.value = true;
                return;
            }
            hasOutsideWindowError.value = false;
        };
        const validateMinimumAdvanceTime = () => {
            if (!hour.value) {
                hasMinimumAdvanceError.value = false;
                return;
            }
            const current = moment();
            const minAllowed = current.clone().add(1, 'hour').seconds(0).milliseconds(0);
            const selectedDate = date.value ? moment(date.value, 'YYYY-MM-DD') : moment();
            const selectedDateTime = moment(`${selectedDate.format('YYYY-MM-DD')} ${hour.value}`, 'YYYY-MM-DD HH:mm')
                .seconds(0)
                .milliseconds(0);
            hasMinimumAdvanceError.value = selectedDateTime.isBefore(minAllowed);
        };
        const validatePeriod = () => {
            validateSendWindow();
            validateMinimumAdvanceTime();
        };
        const setDefaultHour = () => {
            if (hour.value)
                return;
            const base = moment();
            const nextHour = base.clone().add(1, 'hour').seconds(0).milliseconds(0);
            hour.value = nextHour.format('HH:mm');
        };
        const disabledDate = (time) => {
            return moment(time).isBefore(moment().startOf('day'));
        };
        const disabledHours = () => {
            const currentHour = now().hour();
            if (!date.value) {
                return Array.from({ length: currentHour }, (_, i) => i);
            }
            const selectedDate = moment(date.value, 'YYYY-MM-DD');
            return isToday(selectedDate) ? Array.from({ length: currentHour }, (_, i) => i) : [];
        };
        const disabledMinutes = (selectedHour) => {
            const current = now();
            const isSameHour = selectedHour === current.hour();
            const isSameDay = date.value ? isToday(moment(date.value, 'YYYY-MM-DD')) : true;
            if (isSameDay && isSameHour) {
                return Array.from({ length: current.minute() }, (_, i) => i);
            }
            return [];
        };
        let validationInterval = null;
        onMounted(() => {
            validateMinimumAdvanceTime();
            validationInterval = setInterval(validateMinimumAdvanceTime, 10000);
            document.addEventListener('visibilitychange', () => {
                if (!document.hidden)
                    validateMinimumAdvanceTime();
            });
        });
        onUnmounted(() => {
            if (validationInterval)
                clearInterval(validationInterval);
        });
        watch([date, hour], validatePeriod);
        watch(shouldShowTooltip, hasError => {
            store.commit('smsCampaigns/SET_HAS_INVALID_FIELDS', { key: 'period', value: hasError });
        });
        watch(hasMinimumAdvanceError, (hasError, prevHasError) => {
            if (hasError && !prevHasError) {
                mixpanelSmsCampaign.errorPeriodInThePast();
            }
        });
        const customPrefix = shallowRef({
            render() {
                return h('i', { class: 'icon icon-calendar-14px' });
            },
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            const _component_el_time_picker = _resolveComponent("el-time-picker");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t('sms-campaigns.period.title')), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.period.date')) + " ", 1),
                            _hoisted_5,
                            _createVNode(_component_el_popover, {
                                trigger: "hover",
                                effect: "dark",
                                placement: "top",
                                width: 260
                            }, {
                                reference: _withCtx(() => [
                                    _hoisted_7
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: _ctx.$t('sms-campaigns.period.date-tooltip')
                                    }, null, 8, _hoisted_6)
                                ]),
                                _: 1
                            })
                        ]),
                        _createVNode(_component_el_date_picker, {
                            modelValue: date.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((date).value = $event)),
                            format: "DD MMM YYYY",
                            "value-format": "YYYY-MM-DD",
                            placeholder: _ctx.$t('sms-campaigns.period.select-date'),
                            "prefix-icon": customPrefix.value,
                            "disabled-date": disabledDate
                        }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('sms-campaigns.period.hour')) + " ", 1),
                            _hoisted_9,
                            _createVNode(_component_el_popover, {
                                trigger: "hover",
                                effect: "dark",
                                placement: "top",
                                width: 260
                            }, {
                                reference: _withCtx(() => [
                                    _hoisted_11
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: _ctx.$t('sms-campaigns.period.hour-tooltip')
                                    }, null, 8, _hoisted_10)
                                ]),
                                _: 1
                            })
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                            (_openBlock(), _createBlock(_component_el_time_picker, {
                                onFocus: setDefaultHour,
                                key: date.value,
                                placeholder: _ctx.$t('sms-campaigns.period.select-hour'),
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                modelValue: hour.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((hour).value = $event)),
                                "prefix-icon": customPrefix.value,
                                "disabled-hours": disabledHours,
                                "disabled-minutes": disabledMinutes,
                                class: _normalizeClass({ 'sms-campaigns-period__time--error': shouldShowTooltip.value })
                            }, null, 8, ["placeholder", "modelValue", "prefix-icon", "class"]))
                        ])), [
                            [
                                _directive_tooltip,
                                {
                                    theme: 'error',
                                    html: true,
                                    autoHide: false,
                                    distance: 14,
                                    content: activeTooltipKey.value ? _ctx.$t(activeTooltipKey.value) : '',
                                    shown: shouldShowTooltip.value,
                                },
                                void 0,
                                { right: true }
                            ]
                        ])
                    ])
                ])
            ]));
        };
    }
});
